const PERIOD_MAX = 3012 - 1;
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const THREE_HOURS = 3 * HOUR;
const WEATHER_PATH = "/data/weather";
const OSCAR_PATH = "/data/oscar";
const MAX_PRODUCT_PERIOD = 2100 - 1850;
const LEVEL_LIST = {
    "0": "surface-level",
    "1": "isobaric-500hPa",
    "2": "isobaric-250hPa",
    "3": "isobaric-70hPa",
    "4": "isobaric-10hPa",
};


const staticVariable = {
    PERIOD_MAX,
    SECOND,
    MINUTE,
    HOUR,
    THREE_HOURS,
    WEATHER_PATH,
    OSCAR_PATH,
    MAX_PRODUCT_PERIOD,
    LEVEL_LIST,
}

export default staticVariable;